import { InertiaApp } from "@inertiajs/inertia-vue";
import Vuex from "vuex";
import Vue from "vue";

Vue.mixin({ methods: { route: window.route } });
Vue.use(InertiaApp);
Vue.use(Vuex);

import VueLodash from "vue-lodash";
import lodash from "lodash";
Vue.use(VueLodash, { lodash: lodash });

import skeleton from "tui-skeleton/skeleton";
Vue.mixin(skeleton);

import PortalVue from "portal-vue";
Vue.use(PortalVue);

import CKEditor from "@ckeditor/ckeditor5-vue";
Vue.use(CKEditor);

import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
Vue.component("multiselect", Multiselect);

import Layout from "./Pages/Layout";
Vue.component("layout", Layout);

import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-default.css";
Vue.use(VueToast);

import Treeselect from "@riophae/vue-treeselect";
Vue.component("treeselect", Treeselect);
import "@riophae/vue-treeselect/dist/vue-treeselect.min.css";

import VueFlatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
Vue.use(VueFlatPickr);

// import { flare } from "@flareapp/flare-client";
// import { flareVue } from "@flareapp/flare-vue";
// Vue.use(flareVue);

// if (process.env.NODE_ENV === "production") {
//     flare.light("uKcXZYL0LhkYMOaDwGvYVMI1ED3QcmR9");
// }

import "@fortawesome/fontawesome-pro/css/all.css";
import "nprogress/nprogress.css";

import "vue-cal/dist/vuecal.css";

const app = document.getElementById("app");

import Store from "./store";
const store = new Vuex.Store(Store);

const query = require("query-string");
Vue.prototype.$query = query;

import mixins from "./mixins";
Vue.mixin(mixins);

import moment from "moment";
Vue.prototype.moment = moment;

new Vue({
    store,
    render: h =>
        h(InertiaApp, {
            props: {
                initialPage: JSON.parse(app.dataset.page),
                resolveComponent: name =>
                    import(`./Pages/${name}`).then(module => module.default)
            }
        })
}).$mount(app);
